module.exports = __webpack_public_path__ + "img/scene5copy01.d9b8e455.png";